import { AuthContext, CommonContext } from '@repo-level/core-front';
import { Background } from 'components/Background';
import { EmailConfirmPopup } from 'components/EmailConfirm';
import { Footer } from 'components/general/Footer';
import { HeaderMobile } from 'components/general/Header/HeaderMobile';
import { Nav } from 'components/general/Nav';
import { AddonsContext } from 'contexts/addons';
import { ModalsContext } from 'contexts/modal';
import { TabBarContext } from 'contexts/tabBarSize';
import { useAutoRegistrationModal } from 'hooks/autoRegistration';
import { useBonusCode } from 'hooks/bonusCode';
import { useNewTermsAndConditions } from 'hooks/newTermsAndConditions';
import { usePaymentNotification } from 'hooks/paymentNotification';
import { use100vh } from 'hooks/realHeight';
import { useScrollToElement } from 'hooks/scroll';
import { useReferralProgramNotifications } from 'hooks/useReferralProgramNotifications';
import { AdditionalModal } from 'modules/additionalModal';
import { useMissionModal } from 'modules/common/hooks/useMissionModal';
import { useGAConfigHook } from 'modules/googleAnalytics';
import { useWn3Mission } from 'modules/missions/hooks';
import type { FC } from 'react';
import { useContext, useEffect } from 'react';
import { useCurrentRoute } from 'react-navi';
import { ScLayout, ScMain } from './styled';

export const Layout: FC = ({ children }) => {
  const { fetchProject } = useContext(CommonContext);
  const { user, setAfterLoginRedirect } = useContext(AuthContext);
  const { modalComponent: modals } = useContext(ModalsContext);
  const { isEmailConfirmationPopup, emailConfirmationPopupHeight } =
    useContext(AddonsContext);

  useAutoRegistrationModal();

  const realHeight = use100vh();

  const { tabBarHeight } = useContext(TabBarContext);

  const {
    url: { query },
  } = useCurrentRoute();

  useEffect(() => {
    if (query['back-url']) {
      setAfterLoginRedirect(query['back-url']);
    }
  }, [query, setAfterLoginRedirect]);

  usePaymentNotification();

  useBonusCode();

  useReferralProgramNotifications();

  useNewTermsAndConditions();

  useScrollToElement();

  useGAConfigHook();

  useMissionModal();

  useWn3Mission();

  useEffect(() => {
    fetchProject();
  }, [fetchProject, user]);

  return (
    <>
      <AdditionalModal bottom={tabBarHeight} />
      <ScLayout
        emailConfirmationPopupHeight={emailConfirmationPopupHeight}
        realHeight={realHeight}
        withEmailConfirmationPopup={isEmailConfirmationPopup}
      >
        {isEmailConfirmationPopup && <EmailConfirmPopup />}
        <Nav />
        <ScMain realHeight={realHeight}>
          <Background />
          <HeaderMobile />

          {children}
          <Footer />
        </ScMain>
      </ScLayout>
      {modals}
    </>
  );
};
